module.exports = __webpack_public_path__ + "static/media/file-question-alt.d3f65a83.svg";